function frFormat(num, decimals) {
  const [int, dec] = Math.abs(num).toFixed(decimals).split(".");
  // narrow no-break space ( ) as thousands separator, comma as decimal
  const intPart = int.replace(/\B(?=(\d{3})+(?!\d))/g, " ");
  const sign = num < 0 ? "-" : "";
  return dec ? `${sign}${intPart},${dec}` : `${sign}${intPart}`;
}

export function fmt(n) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return frFormat(Number(n), 3);
}

export function fmtDec(n, decimals = 3) {
  if (n === null || n === undefined || isNaN(n)) return "—";
  return frFormat(Number(n), decimals);
}

export function showToast(msg, type = "success") {
  const existing = document.querySelector(".gestock-toast");
  if (existing) existing.remove();
  const el = document.createElement("div");
  el.className = `gestock-toast gestock-toast-${type}`;
  el.textContent = msg;
  document.body.appendChild(el);
  setTimeout(() => el.remove(), 2800);
}
